module.exports = __webpack_public_path__ + "assets/media/brian_moseley.ba93294d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/MoseleyTestimonial/brian_moseley.svg
// module id = 2597
// module chunks = 0